import { openBlock as _openBlock, createBlock as _createBlock } from "vue";
import OrderAudit from './OrderAudit@3.0.vue';
import { saveRefundAuditInfo, getRefundAuditInfo, getRefundAuditPerson } from '@/request';
export default {
  name: 'AfterSalesAudit@3.0',
  props: {
    actDept: [null, Object]
  },

  setup(__props) {
    const props = __props;
    const apiOverrides = {
      saveOrderAuditInfo: saveRefundAuditInfo,
      getOrderAuditInfo: getRefundAuditInfo,
      getAuditPerson: getRefundAuditPerson
    };
    return (_ctx, _cache) => {
      return _openBlock(), _createBlock(OrderAudit, {
        actDept: __props.actDept,
        customAuditType: 3,
        apiOverrides: apiOverrides
      }, null, 8, ["actDept"]);
    };
  }

};